import script from "./goal-tracking-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./goal-tracking-modal.vue?vue&type=script&setup=true&lang=js"

import "./goal-tracking-modal.vue?vue&type=style&index=0&id=6e13d384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e13d384"]])

export default __exports__